export default {
    OPEN: "Открыть",
    DOWNLOAD: "Скачать",
    EDIT: "Редактировать",
    DELETE: "Удалить",
    CONFIRM_DELETE_TEXT: "Вы уверены, что хотите удалить этот отчет?",
    CONFIRM_DELETE_HEADER: "Удалить отчет"
};
